<template>
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2461_1160)">
<path d="M17.3691 5.90112L1.6635 5.90112" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="square"/>
<path d="M9 6.2793L9 14.6504" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="square"/>
<path d="M6.5 10.5229L3.56004 10.5229" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="round"/>
<path d="M6.5 12.5371L3.56004 12.5371" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="round"/>
<path d="M6.5 8.50879L3.56004 8.50879" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="round"/>
<path d="M3.24005 4.00513L3.21069 4.00512" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="round"/>
<path d="M5.30273 4.00513L5.27338 4.00512" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="round"/>
<path d="M7.36548 4.00513L7.33612 4.00512" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.7 2.64604V14.3717H17.3V2.64604H1.7ZM1.5 1.44604C0.947715 1.44604 0.5 1.89376 0.5 2.44605V14.5717C0.5 15.124 0.947714 15.5717 1.5 15.5717H17.5C18.0523 15.5717 18.5 15.124 18.5 14.5717V2.44604C18.5 1.89376 18.0523 1.44604 17.5 1.44604H1.5Z" fill="#1D1E20"/>
<path d="M15.7 10.1536C15.9667 10.3075 15.9667 10.6924 15.7 10.8464L11.95 13.0115C11.6833 13.1654 11.35 12.973 11.35 12.6651L11.35 8.33493C11.35 8.02702 11.6833 7.83457 11.95 7.98853L15.7 10.1536Z" stroke="#1D1E20" stroke-width="1.2" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_2461_1160">
<rect width="18" height="18" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>

</template>